export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/past-procedure-queue`,
        name: `${prefix}.past-procedure-queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.past-procedure-queue.index`,
                PageDescription: "Theatre: Past Procedure Queue",
            },
        },
    },
];
